
























import { Component, Vue } from 'vue-property-decorator'
import partCollection, { Part } from '@/models/part'
import firebase, { db } from '@/plugins/firebase'

@Component<PartList>({
  created () {
    this.subscribe()
  },
  destroyed () {
    this.unsubscribe()
  }
})
export default class PartList extends Vue {
  headers = [
    { value: 'createdAt', text: 'createdAt' },
    { value: 'info.plateNo', text: 'info.plateNo' },
    { value: 'firstTime', text: 'firstTime' },
    { value: 'lastTime', text: 'lastTime' },
    { value: 'seconds', text: 'seconds' },
    { value: 'id', text: 'id' }
  ]

  unsubscribe!: firebase.Unsubscribe
  snapshots: firebase.firestore.QueryDocumentSnapshot<Part>[] = []

  async fetch (): Promise<void> {
    // const sn = await tripCollection.get()
  }

  get items (): Part[] {
    return this.snapshots.map(doc => doc.data())
  }

  subscribe (): void {
    this.unsubscribe = partCollection.limit(10).onSnapshot(sn => {
      this.snapshots = sn.docs
    })
  }

  remove (): void {
    if (!confirm('real?')) return
    const batch = db.batch()
    for (const s of this.snapshots) batch.delete(s.ref)
    batch.commit()
  }
}
